interface Step {
  step: string;
  icon: string;
  title: string;
  description: string;
}

export default function HowItWorks({ steps }: { steps: Step[] }) {
  return (
    <section className="w-full py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-guide-line text-xs"></i>
            工作流程
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            四步开启<span className="text-accent-600">团队创作</span>新模式
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            从零到一，只需四个步骤，就能让你的团队告别单打独斗
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((item, idx) => (
            <div key={item.step} className="relative group">
              <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center relative z-10 h-full">
                <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent-100 text-accent-700 font-heading text-sm font-bold mb-4">
                  {item.step}
                </span>
                <div className="w-12 h-12 rounded-xl bg-accent-100/70 flex items-center justify-center mb-4 mx-auto group-hover:bg-accent-500 transition-colors duration-300">
                  <i className={`${item.icon} text-xl text-accent-600 group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-0">
                  <i className="ri-arrow-right-line text-xl text-secondary-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}